export default "/_next/static/images/c93d0de69b7fb30f1a92050699685780.png";